import useWayBillFormV2 from "./useWayBillFormV2";
import globalStyles from "../../../assets/styles/base/globalPage.module.scss";
import { useForm, Controller } from "react-hook-form";
import ViewGenerateWaybillTable from "../ViewGenerateWaybillTable";
import primaryComponents from "../../primaryComponents";
import styles from "./WayBillFormV2.module.scss";

const WayBillFormV2 = () => {
  const {
    orderData,
    setOrderData,
    handleGenerateWaybill,
    generateWaybillMutation,
    setWaybillQty,
    selected,
    waybillQty,
    toggleItem,
    toggleAll,
    allSelected,
    someSelected,
  } = useWayBillFormV2();
  const { control } = useForm({});
  return (
    <>
      <div className={`${globalStyles.tableWrapper} ${styles.GenerateWaybill}`}>
        <div className={styles.GenerateWaybill__header}>
          <div className="w-100 pb-3">
            <Controller
              control={control}
              name="order_id"
              defaultValue={orderData.order_id}
              placeholder="Order ID"
              render={({ field: { onChange } }) => (
                <primaryComponents.OrderComboBox
                  label="Search by Order ID"
                  onChange={(selectedOrder) => {
                    const { id, order_items } = selectedOrder;
                    if (selectedOrder) {
                      const orderItems = order_items
                        ?.filter((order) => order?.product !== null)
                        ?.map((order) => ({
                          item_id: order?.id,
                          waybill_remaining_quantity:
                            order?.waybill_remaining_quantity,
                          quantity: order?.total_remaining_quantity,
                          cart_item_name: order?.cart_item_name,
                        }));

                      onChange(id);
                      setOrderData((prev) => ({
                        ...prev,
                        items: orderItems,
                        order_id: id,
                      }));
                    }
                  }}
                />
              )}
            />
          </div>
        </div>
        <hr />
        <h6 className="pl-4 pt-2 pb-2">Items to Waybill</h6>
        <hr />
        <ViewGenerateWaybillTable
          view={true}
          items={orderData?.items}
          waybillQty={waybillQty}
          setWaybillQty={setWaybillQty}
          control={control}
          selected={selected}
          selectedAll={allSelected}
          toggleAll={toggleAll}
          someSelected={someSelected}
          toggleItem={toggleItem}
        />
      </div>
      <div
        className={`${globalStyles.cardWithBorder} mb-5`}
        style={{ background: "#fff" }}
      >
        <h4>Logistics Details</h4>
        <div
          className={`${globalStyles.cardWithBorder}`}
          style={{ background: "#fff" }}
        >
          <div>
            <primaryComponents.InputFieldV2
              control={control}
              classNames="white"
              name="deliveryAddress"
              label="Customer’s Delivery Address"
              placeholder="Enter details"
              value={orderData?.delivery_address}
              onChange={({ target: { value } }) => {
                setOrderData((prev) => ({
                  ...prev,
                  delivery_address: value,
                }));
              }}
            />
          </div>
          <div className={styles.GenerateWaybill__headerTwo}>
            <div className="w-100 m-2">
              <primaryComponents.InputFieldV2
                control={control}
                classNames="white"
                name="driverName"
                label="Driver’s Name"
                placeholder="Enter details"
                value={orderData?.driver_name}
                onChange={({ target: { value } }) => {
                  setOrderData((prev) => ({
                    ...prev,
                    driver_name: value,
                  }));
                }}
              />
            </div>
            <div className="w-100 m-2">
              <primaryComponents.InputFieldV2
                control={control}
                classNames="white"
                name="driverNumber"
                label="Driver’s Vehicle/Bike Number"
                placeholder="Enter details"
                value={orderData?.driver_number}
                onChange={({ target: { value } }) => {
                  setOrderData((prev) => ({
                    ...prev,
                    driver_number: value,
                  }));
                }}
              />
            </div>
          </div>
          <div className={styles.GenerateWaybill__headerTwo}>
            <div className="w-100 m-2">
              <primaryComponents.PhoneNumberInputFieldV2
                control={control}
                classNames="white"
                name="PhoneNumber"
                label="Driver’s Phone Number"
                placeholder="Enter your customer’s phone number"
                phoneCodeEditable={true}
                value={orderData?.phone_number}
                onChange={({ target: { value } }) => {
                  setOrderData((prev) => ({
                    ...prev,
                    phone_number: value,
                  }));
                }}
                onChangePhoneCode={(val) => {
                  setOrderData((prev) => ({
                    ...prev,
                    phone_code: val,
                  }));
                }}
                countryCode={orderData?.phone_code}
              />
            </div>
            <div className="w-100 m-2">
              <primaryComponents.InputFieldV2
                control={control}
                classNames="white"
                name="delivetCompany"
                label="Delivery Company"
                placeholder="Enter detail"
                value={orderData?.delivery_company}
                onChange={({ target: { value } }) => {
                  setOrderData((prev) => ({
                    ...prev,
                    delivery_company: value,
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.GenerateWaybill__floatingButton}>
        <primaryComponents.Button
          classNames={"w-100 btn btn--primary"}
          onClick={handleGenerateWaybill}
          isLoading={generateWaybillMutation.isLoading}
          isDisabled={generateWaybillMutation.isLoading || !orderData?.order_id}
          loadingText="Generating..."
        >
          Generate Waybill
        </primaryComponents.Button>
      </div>
    </>
  );
};

export default WayBillFormV2;
